module.exports = __webpack_public_path__ + "images/8e41d2462c055fe53297d01baf8a6b63.png";